import React from 'react';

const DottedLineStyle = props => (
  <svg
    width="118"
    height="1"
    viewBox="0 0 118 1"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="0.5" y1="0.5" x2="117.5" y2="0.5" stroke="currentColor" strokeDasharray="2 2" />
  </svg>
);

export default DottedLineStyle;
